<div red-group [attr.state]="state">
  <ng-content></ng-content>
</div>